import React from 'react';
import { useTranslation } from 'react-i18next';

function Interests() {
  const { t } = useTranslation();

  return (
    <section className="interests-section" id="interests">
      <h3>{t('interests.title')}</h3>
      <div className="interests-content">
        <div className="interests">
          <h4>{t('interests.interests')}</h4>
          <p>{t('interests.interests.description')}</p>
          <ul>
            <li>Codage et programmation</li>
            <li>Technologies émergentes</li>
            <li>Design et créativité</li>
            <li>Football</li>
            <li>Divertissements</li>
          </ul>
        </div>
        <div className="languages">
          <h4>{t('interests.languages')}</h4>
          <ul>
            <li>{t('interests.french')}</li>
            <li>{t('interests.english')}</li>
            <li>{t('interests.wolof')}</li>
          </ul>
        </div>
      </div>
      
      <h3>{t('certifications.title')}</h3>
      <div className="certifications-content">
        <ul>
          <li>
            🎓 {t('certifications.ucdavis_vector')}{' '}
            <a href="https://www.coursera.org/account/accomplishments/verify/PCIK7D9VPA5O" target="_blank" rel="noopener noreferrer">
              {t('certifications.verify')}
            </a>
          </li>
          <li>
            🎓 {t('certifications.ucdavis_arcgis')}{' '}
            <a href="https://www.coursera.org/account/accomplishments/verify/PQY6H6BCYXLU" target="_blank" rel="noopener noreferrer">
              {t('certifications.verify')}
            </a>
          </li>
          <li>
            ☁️ {t('certifications.aws')}{' '}
            <a href="https://www.coursera.org/account/accomplishments/verify/G9ALF595LUA4" target="_blank" rel="noopener noreferrer">
              {t('certifications.verify')}
            </a>
          </li>
          <li>
            📡 {t('certifications.iot')}{' '}
            <a href="https://coursera.org/verify/QMNDY3XR7AKR" target="_blank" rel="noopener noreferrer">
              {t('certifications.verify')}
            </a>
          </li>
          <li>🌐 {t('certifications.web')}</li>
          <li>🛸 {t('certifications.agisoft')}</li>
          <li>🗺️ {t('certifications.arcgis')}</li>
          <li>🌍 {t('certifications.digital')}</li>
        </ul>
      </div>
      
      <h3>{t('additional.title')}</h3>
      <div className="additional-content">
        <ul>
          <li>{t('additional.teamwork')}</li>
          <li>{t('additional.adaptability')}</li>
          <li>{t('additional.international')}</li>
          <li>{t('additional.passion')}</li>
        </ul>
      </div>
    </section>
  );
}

export default Interests; 